import React from 'react';
/** Components Import */
import { Backdrop as MuiBackdrop, CircularProgress, Fade } from '@mui/material';

function LoadingBasic({
  open = false, // bool
  children = <CircularProgress color="inherit" />, // node
  classes, // object
  component, // elementType
  components, // { Root?: elementType }
  componentsProps, // { root?: object }
  invisible = false, // bool
  slotProps, // { root?: object }
  slots, // { root?: elementType }
  sx, // object
  TransitionComponent = Fade, // elementType
  transitionDuration, // number | { appear?: number, enter?: number, exit?: number }
  onClick = () => {},
}) {
  const ClickBackdrop = () => {
    onClick();
  };

  return (
    <MuiBackdrop
      open={open}
      classes={classes}
      component={component}
      components={components}
      componentsProps={componentsProps}
      invisible={invisible}
      slotProps={slotProps}
      slots={slots}
      sx={{
        zIndex: 2000,
        ...sx,
      }}
      TransitionComponent={TransitionComponent}
      transitionDuration={transitionDuration}
      onClick={ClickBackdrop}
    >
      {children}
    </MuiBackdrop>
  );
}

export default React.memo(LoadingBasic);
